import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=085a056d&scoped=true"
import script from "./offline.vue?vue&type=script&lang=js"
export * from "./offline.vue?vue&type=script&lang=js"
import style0 from "./offline.vue?vue&type=style&index=0&id=085a056d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085a056d",
  null
  
)

export default component.exports